<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:20px; padding-top:100px;">About the Author</h1>
<p>Kira Metzger is a mother of four. Writing has always been her passion. She works besides studying in a college. She wants to be a role model for her kids.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?35b4207c